///home/clement/compta-app/client/src/components/Stocks/Produits/AjouterProduitService.js

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { TextField, Button, Box, Typography, MenuItem } from "@mui/material";

const AjouterProduitService = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    nom: "",
    description: "",
    prixUnitaire: 0,
    quantite: 0,
    type: "produit", // "produit" ou "service"
    categorie: "",
    tva: 20, // TVA par défaut
  });
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.nom) newErrors.nom = "Le nom est obligatoire";
    if (formData.prixUnitaire <= 0) newErrors.prixUnitaire = "Le prix doit être supérieur à 0";
    if (formData.quantite < 0) newErrors.quantite = "La quantité ne peut pas être négative";
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    try {
      // Appel à ton API pour créer le produit/service
      const response = await fetch("/api/produits-services", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });
      if (response.ok) {
        alert("Produit/Service ajouté avec succès !");
        navigate("/stocks/produits"); // Redirection après succès
      } else {
        throw new Error("Erreur lors de l'ajout");
      }
    } catch (error) {
      alert(`Erreur : ${error.message}`);
    }
  };

  return (
    <Box sx={{ maxWidth: 600, mx: "auto", p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Ajouter un Produit/Service
      </Typography>
      <form onSubmit={handleSubmit}>
        <TextField
          fullWidth
          margin="normal"
          label="Nom"
          name="nom"
          value={formData.nom}
          onChange={handleChange}
          error={!!errors.nom}
          helperText={errors.nom}
        />
        <TextField
          fullWidth
          margin="normal"
          label="Description"
          name="description"
          multiline
          rows={3}
          value={formData.description}
          onChange={handleChange}
        />
        <TextField
          fullWidth
          margin="normal"
          label="Prix unitaire (€)"
          name="prixUnitaire"
          type="number"
          value={formData.prixUnitaire}
          onChange={handleChange}
          error={!!errors.prixUnitaire}
          helperText={errors.prixUnitaire}
        />
        <TextField
          fullWidth
          margin="normal"
          label="Quantité en stock"
          name="quantite"
          type="number"
          value={formData.quantite}
          onChange={handleChange}
          error={!!errors.quantite}
          helperText={errors.quantite}
        />
        <TextField
          fullWidth
          margin="normal"
          label="Type"
          name="type"
          select
          value={formData.type}
          onChange={handleChange}
        >
          <MenuItem value="produit">Produit</MenuItem>
          <MenuItem value="service">Service</MenuItem>
        </TextField>
        <TextField
          fullWidth
          margin="normal"
          label="Catégorie"
          name="categorie"
          value={formData.categorie}
          onChange={handleChange}
        />
        <TextField
          fullWidth
          margin="normal"
          label="TVA (%)"
          name="tva"
          type="number"
          value={formData.tva}
          onChange={handleChange}
        />
        <Box sx={{ mt: 2 }}>
          <Button type="submit" variant="contained" color="primary">
            Enregistrer
          </Button>
        </Box>
      </form>
    </Box>
  );
};

export default AjouterProduitService;
